import { Component, OnInit, ViewChild } from '@angular/core';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GetBucketContentParams } from '@app-diagnostics/common/diagnostics.model';
import { DiagnosticsService } from '@app-diagnostics/services/diagnostics.service';

import {
  DIAGNOSTICS_TABLE_COLUMNS,
  DIAGNOSTICS_TABLE_PAGE_SIZES,
  DIAGNOSTICS_VIDEO_TABLE_COLUMNS,
  DIAGNOSTICS_VIDEO_TABLE_PAGE_SIZES,
} from '@app-diagnostics/common/diagnostics.constants';
@Component({
  selector: 'app-diagnostics',
  templateUrl: './diagnostics.component.html',
  styleUrls: ['./diagnostics.component.scss'],
})
export class DiagnosticsComponent implements OnInit {
  public diagnosticsTablePageSizes: number[] = DIAGNOSTICS_TABLE_PAGE_SIZES;
  public diagnosticsDisplayedColumns: string[] = DIAGNOSTICS_TABLE_COLUMNS;

  public videoTablePageSizes: number[] = DIAGNOSTICS_VIDEO_TABLE_PAGE_SIZES;
  public VideoDisplayedColumns: string[] = DIAGNOSTICS_VIDEO_TABLE_COLUMNS;

  public diagnosticsDataSource: MatTableDataSource<any[]> = new MatTableDataSource([]);
  public videoDataSource = new MatTableDataSource<any[]>([]);

  public accountCode: string;
  public cameraSerialID: string;

  public previousSerialID: string;

  public show = 'no content';
  @ViewChild('diagnosticsPaginator', { static: true })
  public diagnosticsPaginator: MatPaginator;

  @ViewChild('videoPaginator', { static: true })
  public videoPaginator: MatPaginator;

  @ViewChild('diagnosticsSort', { static: true })
  private diagnosticsSort: MatSort;

  @ViewChild('videoSort', { static: true })
  private videoSort: MatSort;

  constructor(private _diagnosticsService: DiagnosticsService) {}
  public ngOnInit() {
    this.diagnosticsDataSource.paginator = this.diagnosticsPaginator;
    this.videoDataSource.paginator = this.videoPaginator;

    this.diagnosticsDataSource.sort = this.diagnosticsSort;
    this.videoDataSource.sort = this.videoSort;
  }

  public onSubmit() {
    if (this.cameraSerialID.length) {
      this.previousSerialID = this.cameraSerialID;
      this.show = 'spinner';
      this.getDiagnosticsData();
    }
  }

  private getDiagnosticsData() {
    const params = new GetBucketContentParams(this.cameraSerialID);
    this._diagnosticsService.getBucketData(params).subscribe(
      (res) => {
        if (res.length > 0) {
          this.show = 'content';
          const diagnosticFileDetails: any = [];
          const rawStreamdetails: any = [];
          let dCount = 0;
          let rCount = 0;
          res.forEach((element) => {
            if (element.value) {
              const file: string = element.value.diagnosticFiledetails;
              const rawFile: string = element.value.rawStreamdetails;
              if (file) {
                const i = file.lastIndexOf('/');
                const displayName = file.substring(i + 1);
                diagnosticFileDetails.push({ srNo: ++dCount, fileName: file, displayName });
              }
              if (rawFile) {
                const i = rawFile.lastIndexOf('/');
                const displayName = rawFile.substring(i + 1);
                rawStreamdetails.push({ srNo: ++rCount, fileName: rawFile, displayName });
              }
            }
          });
          this.diagnosticsDataSource.data = diagnosticFileDetails;
          this.videoDataSource.data = rawStreamdetails;
        } else {
          this.show = 'no content';
        }
      },
      (err) => {
        this.show = 'no content';
        console.log(err);
      }
    );
  }
}
